<template>
  <div :class="[prefixUploadClass + '-list']">
    <div v-for="(file, fileIndex) in files"
         :key="fileIndex"
         :class="$_fileClasses(file)"
         @click="$_onUploadListClick(file)">
      <div class="upload-list__info" @click="$_onUploadListPreviewClick(file)">
        <template>
          <t-icon :type="$_format(file)"></t-icon>
          <a :href="file.url" target="_blank" class="upload-list__name">{{ file.name }}</a>
        </template>
      </div>
      <t-icon v-show="file.status === 'finished'"
              title="Remove file"
              type="close"
              @click.native.stop="$_onRemoveIconClick(file)"></t-icon>
      <transition name="fade">
        <t-progress
          :stroke-width="2"
          :percent="parsePercentage(file.percentage)"
          :status="file.status === 'finished' && file.showProgress ? 'success' : 'normal'"></t-progress>
      </transition>
    </div>
  </div>
</template>
<script>
import TIcon from '../icon/icon.vue'
import TProgress from '../progress/progress.vue'
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_UPLOAD_CLASS = `${PREFIX_CLASS}upload`

export default {
  name: 'UploadList',
  components: { TIcon, TProgress },
  props: {
    files: {
      type: Array,
      default() {
        return []
      }
    },
    imgView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      prefixUploadClass: PREFIX_UPLOAD_CLASS
    }
  },
  methods: {
    $_fileClasses(file) {
      return [
        `${PREFIX_UPLOAD_CLASS}-list__item`,
        {
          [`${PREFIX_UPLOAD_CLASS}-list__item--done`]: file.status === 'finished'
        }
      ]
    },
    $_onUploadListClick(file) {
      this.$emit('on-file-click', file)
    },
    $_onUploadListPreviewClick(file) {
      this.$emit('on-file-preview', file)
    },
    $_onRemoveIconClick(file) {
      this.$emit('on-file-remove', file)
    },
    $_format(file) {
      const format =
        file.name
          .split('.')
          .pop()
          .toLocaleLowerCase() || ''
      let type = 'document'
      if (['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'].indexOf(format) > -1) {
        type = 'file-image'
      }
      if (
        ['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'].indexOf(
          format
        ) > -1
      ) {
        type = 'film'
      }
      if (['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'].indexOf(format) > -1) {
        type = 'file-music'
      }
      if (['doc', 'txt', 'docx', 'pages', 'epub', 'pdf'].indexOf(format) > -1) {
        type = 'file-document'
      }
      if (['numbers', 'csv', 'xls', 'xlsx'].indexOf(format) > -1) {
        type = 'file-excel'
      }
      if (['keynote', 'ppt', 'pptx'].indexOf(format) > -1) {
        type = 'file-powerpoint'
      }
      return type
    },
    parsePercentage(val) {
      return parseInt(val, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// upload-list.vue?0280eeaf